import Vue from 'vue'
import Router from 'vue-router'
//import Intro from './views/Intro.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior: function (to, from, savedPosition) {
		if (to.hash) {
			return {
				selector: to.hash
			}
		} else if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0
			}
		}
	},
	routes: [
		{
			path: '/',
			name: 'intro',
			component: () => import( /* webpackChunkName: "Intro" */ './views/Intro.vue')
		},
		{
			path: '/',
			name: 'intro',
			component: () => import( /* webpackChunkName: "Intro" */ './views/Intro.vue')
		},
		{
			path: '/tutorial',
			name: 'how-to-use',
			component: () => import( /* webpackChunkName: "Tutorial" */ './views/HowToUse.vue')
		},
		{
			path: '/alege-dispozitiv',
			name: 'chose-device',
			component: () => import( /* webpackChunkName: "Alege dispozitiv" */ './views/ChoseDevice.vue')
		},
		{
			path: '/alege-dispozitiv/iqos-3',
			name: 'iqos-3',
			component: () => import( /* webpackChunkName: "Iqos 3" */ './views/Devices/Iqos-3.vue')
		},
		{
			path: '/alege-dispozitiv/iqos-multi',
			name: 'iqos-multi',
			component: () => import( /* webpackChunkName: "Iqos multi" */ './views/Devices/Iqos-multi.vue')
		},
		{
			path: '/alege-dispozitiv/iqos-2-4',
			name: 'iqos-2-4',
			component: () => import( /* webpackChunkName: "Iqos 2.4" */ './views/Devices/Iqos-2-4.vue')
		},
		{
			path: '/faq',
			name: 'faq',
			component: () => import( /* webpackChunkName: "Iqos 2.4" */ './views/Faq.vue')
		},
		// {
		//   path: '/about',
		//   name: 'about',
		//   // route level code-splitting
		//   // this generates a separate chunk (about.[hash].js) for this route
		//   // which is lazy-loaded when the route is visited.
		//   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		// }
	]
})